import { Column } from "@bridgesplit/ui";
import { LoopscalePointsAction } from "@bridgesplit/abf-react";
import { TokenListMetadata } from "@bridgesplit/abf-sdk";

import { RewardsDailyPointsDisplay } from "./RewardsDailyPointsDisplay";
import { RewardsDailyPointsBreakdown } from "./RewardsDailyPointsBreakdown";

export interface RewardsDailyPointsProps {
    loopscalePointsAction: LoopscalePointsAction;
    identifier: string | undefined;
    collateralMetadata?: TokenListMetadata | undefined; //Used for loops to show collateral boost
    principalBorrowedWithLeverageUsd?: number; //Used for loops to show max leverage based on loops, and for portfolio
}
export function RewardsDailyPoints(props: RewardsDailyPointsProps) {
    return (
        <Column spacing={0.5}>
            <RewardsDailyPointsDisplay {...props} />
            <Column sx={{ paddingLeft: 1.5 }}>
                <RewardsDailyPointsBreakdown {...props} />
            </Column>
        </Column>
    );
}
